module.exports = __webpack_public_path__ + "img/marcoisland-dock-bg.05939a0a.jpg";